module.exports = __webpack_public_path__ + "static/img/logo-splash.24fe862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/logo-splash.png
// module id = Oegw
// module chunks = 0